module.exports = __webpack_public_path__ + "img/motor_no73.dc8e12b2.jpg";